export default "__VITE_ASSET__DDGocvhV__"